/**
 * PLP
 */
// if shop filters exists
(() => {
  const query = document.querySelector('.shop-filters');
  if (!query) return;

  // splitting filter name from filter count, so we can style them
  const filtersLoaded = () => {
    const filterItems = document.querySelectorAll('.shop-filters .filter-options:not(.swatch-grid) a:not(.lessfilteroption, .morefilteroption)');
    filterItems.forEach((item) => {
      let filterText = item.textContent;
      filterText = filterText.replace(/\s+[(]/g, ';(');
      const filterSplit = filterText.split(';');
      item.innerHTML = `<span class="filterOptionName">${filterSplit[0]}</span><span class="filterOptionCount">${filterSplit[1]}</span>`;
    });
  };

  // watch for skeleton filters being unhidden (data is loaded)
  const observer = new MutationObserver((e) => {
    if (e[0].target.style.display !== 'none') {
      console.log('filters loaded');
      filtersLoaded();
    }
  });

  const skeleton = document.querySelector('.skeleton-filters');
  if (skeleton) {
    observer.observe(skeleton, { attributes: true, childList: true });
  }

  /**
   * If no products (sub-categories only) manipulate layout
   */
  (() => {
    const productFilters = document.querySelector('.filterswrapper');
    if (!productFilters) {
      document.body.classList.add('plp-nosidebar');

      const pageHero = document.querySelector('.page-title');
      if (!pageHero) return;

      const catTitle = document.querySelector('.subcategorieslist_container .catalog-name')?.textContent;
      const catText = document.querySelector('.subcategorieslist_container .catalog-content p:first-child')?.textContent;

      pageHero.querySelector('.page-title-content h1').textContent = catTitle;
      pageHero.querySelector('.page-title-content p').textContent = catText;

      const updateTitle = pageHero.querySelector('.page-title-content h1').innerHTML.replace(/^\s*\w+/, '<span class="text-orange">$&</span>');
      pageHero.querySelector('.page-title-content h1').innerHTML = updateTitle;

      pageHero.parentNode.classList.remove('hide');
      document.body.classList.add('ex-hero');
    }
  })();
})();

/**
 * clone per-page to upper grid tools, then move inline with breadcrumb
 */
(() => {
  const listtools = document.querySelector('.productsgrid_container .gridtools .listtools') || document.querySelector('.subcategorieslist_container .gridtools .listtools');
  if (!listtools) return;

  const perPage = document.querySelector('.productsgrid_container .productperpage');
  if (perPage) {
    listtools?.prepend(perPage.parentNode.cloneNode(true));
  }

  document.querySelector('.row-breadcrumb')?.classList.add('breadcrumb-flex');
  document.querySelector('.row-breadcrumb')?.append(listtools.closest('.gridtools'));
})();

/**
 * Move title to breadcrumb
 */
(() => {
  const prodGridContainer = document.querySelector('.productsgrid_container');
  if (!prodGridContainer) return;

  const catName = prodGridContainer.querySelector('.catalog-name')?.textContent || '';

  if (catName) {
    const breadCrumbLi = document.createElement('li');
    breadCrumbLi.innerHTML = catName;
    document.querySelector('.breadcrumb')?.append(breadCrumbLi);
  }
})();

/**
 * PLP Product Loop
 */
const plpLoop = () => {
  const prodGrid = document.querySelector('.productgridwidget');
  if (!prodGrid) return;

  prodGrid.querySelectorAll('.product').forEach((product) => {
    if (product.querySelector('.product-stock-wrap')) return; // do not run if already done

    // layout changes
    const footWrapBot = document.createElement('div');
    footWrapBot.className = 'foot-wrap-bot';
    product.querySelector('.footer-wrapper')?.append(footWrapBot);
    product.querySelector('.footer-wrapper-price')?.prepend(product.querySelector('.product-sku'));
    product.querySelector('.foot-wrap-bot')?.append(product.querySelector('.footer-wrapper-price'));

    // product warehouse stock
    const locations = product.querySelector('.showproductlocations');

    const stockWrap = document.createElement('div');
    stockWrap.className = 'product-stock-wrap';

    if (locations) {
      const locationDataRaw = locations.getAttribute('data-locations');

      try {
        const locData = JSON.parse(locationDataRaw);
        locData.forEach((data) => {
          const stockEntry = document.createElement('div');
          stockEntry.className = 'stock-entry';
          stockEntry.innerHTML = /* html */ `
            <span class="stock-warehouse">${data.warehouse}</span>
            <span class="stock-quanitity">${data.quantity}</span>
          `;
          stockWrap.append(stockEntry);
        });
      } catch {
        console.log('invalid');
      }
    } else {
      const outOfStock = product.querySelector('.out-stock');
      const isMaster = product.getAttribute('data-configurablemaster') === '1';

      if (isMaster) return; // do not show for master products
      if (!outOfStock) return; // DO show if otherwise, .out-stock class exists

      stockWrap.innerHTML = /* html */ `
        <div class="stock-entry">
          <span class="stock-warehouse">Next Day Stock</span>
          <span class="stock-quanitity">0</span>
        </div>
        <div class="stock-entry">
          <span class="stock-warehouse">Group Stock</span>
          <span class="stock-quanitity">0</span>
        </div>
      `;
    }

    product.querySelector('.foot-wrap-bot')?.append(stockWrap);
  });
};

// document.addEventListener('live-inventory-done', function () {
  plpLoop();
// }, false);


document.addEventListener('product-loadmore-success', (e) => {
  console.log('More products loaded', e.detail);
  plpLoop();
}, false);
